import React from "react";
import "./styles.scss";
import { MessageLocal } from "app/api/types";

interface IProps {
	message: MessageLocal,
	name: null | string,
}

interface IState {

}

class ChatFormMessage extends React.Component<IProps, IState> {
	render() {
		const style = 'chat-form-message ' + (
			this.props.message.isIncoming
				? 'chat-form-message_income'
				: 'chat-form-message_outcome');

		return (<div className={style}>
			{
				(<div className={'chat-form-message__name'}>
					{`(${this.props.message.isIncoming ? this.props.name : 'Вы'}) ${this.props.message.time.toLocal().toFormat('HH:mm dd.MM.yyyy') ?? 'Недавно'}`}
				</div>)
			}
			<div>
				{this.props.message.text}
			</div>
		</div>);
	}
}

export default ChatFormMessage;
